import React, { useState } from 'react';
import MessageForm from '../MessageForm/MessageForm';
import Particles from 'react-particles-js';

const Header = () => {
    const [modalIsOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <section className="header-container d-flex justify-content-center align-items-center flex-column" id="home">
            <Particles width="100%" className="particles-js"
                params={{
                    interactivity: {
                        detectsOn: "canvas",
                        events: {
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        }
                    },
                    particles: {
                        line_linked: {
                            distance: 150,
                            shadow: {
                                enable: true,
                                color: "#000",
                                blur: 0.3
                            }
                        }
                    }
                }}
            />
            <div style={{zIndex: 0 }}>
                <div className="animated-text-container d-flex flex-column text-center">
                    <span className="text1">Kazi Mashry</span>
                    <span className="text2">Learner  |  Programmer  |  Developer</span>
                </div>
                <div className="header-button-container d-flex flex-wrap justify-content-center">
                    <button type="button" className="btn btn-light ml-2 mt-3" onClick={openModal}>
                        Send Message
                </button>

                    <a className="text-decoration-none" style={{ color: '#f5f5f7' }} href="https://drive.google.com/uc?export=download&id=1fMBG5_W4IFeg4qeYRuDA6jNetPqrfMYk" target="blank">
                        <button type="button" className="btn btn-dark ml-2 mt-3">Download Resume</button>
                    </a>
                </div>
            </div>
            <div><MessageForm modalIsOpen={modalIsOpen} closeModal={closeModal} /></div>
        </section>
    );
};

export default Header;